<template>
  <div class="hello">
    <div class="text-titel">羽行用户管理</div>
    <div class="box-top">
      <div class="box-top">
        <el-input placeholder="请输入内容" v-model="input" clearable>
        </el-input>
        <el-button type="primary" round @click="themebutton">查询</el-button>
      </div>
      <div>
        <el-button type="primary" round @click="userbtton">添加</el-button>
      </div>
    </div>
    <div class="infinite-list-wrapper" style="overflow: auto">
      <div v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <div style="background: #e1ffff; padding: 17px">
          <div style="display: flex; justify-content: space-between">
            <div>问号</div>
            <div>ID:34567890</div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div>
              <div>备注名称:</div>
              <div>备注信息:</div>
              <div>获得称号:</div>
            </div>
            <div>
              <div style="margin-top: 7px; font-size: 23px; margin-bottom: 7px">
                积分：99
              </div>
              <div style="display: flex">
                <div>编辑</div>
                <div>删除</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p v-if="loading">加载中...</p>
      <p v-if="noMore">没有更多了</p>
    </div>

    <!-- <div class="box-button">
      <el-button type="primary" round @click="themebutton">提交</el-button>
    </div> -->
  </div>
</template>
<script>
import { MessageBox } from "mint-ui";

export default {
  name: "bindDetail",
  data() {
    return {
      list: [],

      count: 10,
      loading: false,
      partnerinput: "",
      userinput: "",
      recordsdata: {
        id: "",
        projId: "",
        username: "",
        level: "",
        devSysName: "",
        integral: "",
        comment: "",
        remarks: "",
      },
      valuedata: [],
      loading: false,
      input: "",
      isShow: false,
      request: {
        phone: "",
        openId: "",
      },
      user: {},
      count: 10,
      // loading: false,
      loading: false,
    };
  },
  computed: {
    noMore() {
      return this.count >= 90;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  mounted() {
    this.request.openId = this.$route.query.openId;
    if (this.request.openId) {
      this.getUserInfo();
    }
  },
  methods: {
    load() {
      // this.loading = true;
      this.loading = false;
      setTimeout(() => {
        this.count += 2;
        this.loading = false;
      }, 2000);
      // console.log(123);
    },

    userbtton(query) {
      this.$router.push({
        path: "/featheruser",
        query: query,
      });
    },
    // 提交
    themebutton() {
      console.log("查询列表");
      var _t = this;
      this.common.dofeathera(
        this.common.users,
        { current: 1, size: 10, username:_t.input },
        function (res) {
          console.log(res);
        },
        "weixin"
      );
    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t = this;
      this.common.doActionGet(
        this.common.bindIsOk,
        { openId: this.request.openId },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            _t.user = res.data;
            _t.request.phone = res.data.userphone;
          } else if (res.code == 201) {
            //未绑定微信
            var query = {
              openId: _t.request.openId,
            };
            _t.$router.push({
              path: "/bindPhone",
              query: query,
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
      this.isShow = true;
    },
    unbindWeChat() {
      var _t = this;
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then((action) => {
          _t.common.doActionGet(
            _t.common.removeBindLny,
            _t.request,
            function (res) {
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId,
                };
                _t.$router.push({
                  path: "/bindPhone",
                  query: query,
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "weixin"
          );
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
  margin-top: -40px;
}
.title1 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top: 20px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 75px;
  text-align: left;
}
.tip {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top: 14px;
}
.btn-code {
  width: 80px;
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
}
.btn-gray {
  width: 100%;
  height: 40px;
  margin-top: 100px;
}
.wechat-user-logo {
  margin-top: 80px;
}
.box-one {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.text-titel {
  width: 100%;
  padding: 20px 0px;
  font-size: 20px;
}
.box-button {
  margin-top: 30%;
}
.box-top {
  display: flex;
}
.wrap {
  /* height: 100vh; */
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/featheradd/featherhomeuser.vue